export class PBMMapper {
  static map(parceiroPbm: string, integradoPbmComSucesso: boolean | null) {
    let pbmStatus: 'disabled' | 'success' | 'error' = 'disabled'

    if (integradoPbmComSucesso === true) {
      pbmStatus = 'success'
    } else if (integradoPbmComSucesso === false) {
      pbmStatus = 'error'
    }

    return {
      pbmStatus,
      pbmPartner: parceiroPbm,
    }
  }
}
